import { render, staticRenderFns } from "./CurrencyRateParametersWidgetWithoutStore.vue?vue&type=template&id=04273d4a&"
import script from "./CurrencyRateParametersWidgetWithoutStore.vue?vue&type=script&lang=js&"
export * from "./CurrencyRateParametersWidgetWithoutStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports